import API from './API.js'

export default class Bonuses extends API {
  constructor() {
    super('bonuses')
  }
}
